import { useSnackbar } from "notistack";
import { GetAllPackagesUseCase } from "../../../domain/usecase/package/getAll/GetAllUseCase";
import { useEffect, useState } from "react";
import { Package } from "../../../domain/model/Package";
import { State } from "../../../domain/model/ResponseState";
import { CheckDiscountCodeIfRedeemableUseCase } from "../../../domain/usecase/discountCode/checkIfRedeemable/UseCase";
import { DiscountCodeType } from "../../../domain/model/DiscountCode";
import { RedeemDiscountCodeUseCase } from "../../../domain/usecase/discountCode/redeem/UseCase";
import {
  getUserInfoAgain,
  showGlobalLoadingView,
} from "../../../core/utils/Utils";

export function ChoosePackageViewModel(
  getAllPackagesUseCase: GetAllPackagesUseCase,
  checkDiscountCodeIfRedeemableUseCase: CheckDiscountCodeIfRedeemableUseCase,
  redeemDiscountCodeUseCase: RedeemDiscountCodeUseCase
) {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [packages, setPackages] = useState<Array<Package> | undefined>([]);
  const [discountCode, setDiscountCode] = useState<string>();

  useEffect(() => {
    getPackages();
  }, []);

  async function checkIfFreeGameCodeRedeemable() {
    if (!discountCode) return;
    showGlobalLoadingView(true);
    const response = await checkDiscountCodeIfRedeemableUseCase.invoke({
      type: DiscountCodeType.FREE_GAME,
      code: discountCode,
    });
    switch (response.responseState) {
      case State.Success:
        if (response.data?.canBeUsed && response.data.discountCodeId) {
          await redeemFreeGameCode(response.data.discountCodeId);
        } else {
          showGlobalLoadingView(false);
          showSnackbar(response.data?.message);
        }
        break;
      case State.Fail:
      case State.Error:
        showGlobalLoadingView(false);
        showSnackbar(response.error?.message);
        break;
    }
  }

  async function redeemFreeGameCode(codeId: string) {
    const response = await redeemDiscountCodeUseCase.invoke(codeId);
    showGlobalLoadingView(false);
    switch (response.responseState) {
      case State.Success:
        showSnackbar(response.data?.message, "success");
        getUserInfoAgain();
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  async function getPackages() {
    setLoading(true);
    const response = await getAllPackagesUseCase.invoke();
    switch (response.responseState) {
      case State.Success:
        setPackages(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    setLoading(false);
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }
  return {
    packages,
    loading,
    checkIfFreeGameCodeRedeemable,
    discountCode,
    setDiscountCode,
  };
}
